<section class="breadcrumb-section-main inner-2 breadcrumb-section-sm">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="breadcrumb-contain ">
                    <div>
                        <h2 class="breadcrumb-txt">{{ breadcrumbTitle }}</h2>
                    </div>
                    <div>
                        <ul>
                            <li *ngFor="let crumb of breadcrumbs; let last = last">
                                <a [href]="crumb.link || '#'">
                                    <ng-container *ngIf="crumb.iconClass">
                                        <i [class]="crumb.iconClass"></i>
                                    </ng-container>
                                    {{ crumb.label }}
                                </a>
                                <ng-container *ngIf="!last"> </ng-container>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section id="how-work" class="saas1 howitwork" [ngStyle]="{'background-image': 'url(' + backgroundImage + ')'}">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <div class="title">
                    <img [src]="titleImagePath" alt="title-logo" class="img-fluid">
                    <div class="main-title">
                        <h2>{{ mainTitle }}</h2>
                    </div>
                    <hr>
                    <div class="sub-title">
                        <p class="p-padding">{{ subtitle }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
